/* eslint-disable */

<template>
  <div class="w-full bg-dark main-border rounded-lg p-4 mt-8">
    <div>
      <h4>{{ activeCourseInfo.name }} Quick Learn</h4>
      <p class="text-dark">Select an assignment, simulation, virtual lab, or flashcard set from those randomly chosen below.</p>
    </div>

    <div class="grid grid-cols-4 gap-4 mt-4" id="quick-learn-grid">
      <div class="flex bg-light main-border rounded-lg p-4" v-if="quickLearnFetched" v-for="simulation in quickLearnSimulation">
        <div class="flex basis-1/4 items-center">
          <img :src="simulation?.thumbnail" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-solid fa-cubes" class="h-4 w-4" />
              <p>Simulation</p>
            </span>
            <h4>{{ truncateText(simulation?.name, 31) }}</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/simulations/${simulation.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="quickLearnFetched" v-for="flashcard in quickLearnFlashCard">
        <div class="flex basis-1/4 items-center">
          <img :src="flashcard?.thumbnail" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-rectangle-list" class="h-4 w-4" />
              <p>FlashCard Set</p>
            </span>
            <h4>{{ truncateText(flashcard?.name, 31) }}</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/flashcards/${flashcard.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="quickLearnFetched" v-for="assignment in quickLearnExamEdge">
        <div class="flex basis-1/4 items-center">
          <img :src="activeCourseInfo?.thumbnail" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-file-lines" class="h-4 w-4" />
              <p>ExamEdge Assignment</p>
            </span>
            <h4>{{ truncateText(assignment?.name, 31) }}</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/examedge/select`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="quickLearnFetched" v-for="lab in quickLearnLab">
        <div class="flex basis-1/4 items-center">
          <img :src="lab?.thumbnail" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-flask" class="h-4 w-4" />
              <p>Virtual Lab</p>
            </span>
            <h4>{{ truncateText(lab?.name, 31) }}</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/labs/${lab.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <!-- PLACEHOLDER DEFAULT CARDS -->

      <div class="flex bg-light main-border rounded-lg p-4" v-if="!quickLearnFetched">
        <div class="flex basis-1/4">
          <img :src="simulationPlaceholderImage" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-solid fa-cubes" class="h-4 w-4" />
              <p>Simulation</p>
            </span>
            <h4>Randomly Selecting Simulation...</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            disabled
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/labs/${lab.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="!quickLearnFetched">
        <div class="flex basis-1/4">
          <img :src="flashcardPlaceholderImage" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-rectangle-list" class="h-4 w-4" />
              <p>FlashCard Set</p>
            </span>
            <h4>Randomly Selecting FlashCard Set...</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            disabled
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/labs/${lab.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="!quickLearnFetched">
        <div class="flex basis-1/4">
          <img :src="examedgePlaceholderImage" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-file-lines" class="h-4 w-4" />
              <p>ExamEdge Assignment</p>
            </span>
            <h4>Randomly Selecting Assignment...</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            disabled
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/labs/${lab.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>

      <div class="flex bg-light main-border rounded-lg p-4" v-if="!quickLearnFetched">
        <div class="flex basis-1/4">
          <img :src="labPlaceholderImage" width="125" height="125" class="rounded-lg hidden lg:block" alt="" />
        </div>

        <div class="flex flex-col justify-between basis-3/4 ml-4 w-full">
          <div>
            <span class="flex items-center gap-x-1 text-dark">
              <font-awesome-icon icon="fa-regular fa-flask" class="h-4 w-4" />
              <p>Virtual Lab</p>
            </span>
            <h4>Randomly Selecting Virtual Lab...</h4>
          </div>

          <vs-button
            color="dark"
            icon-pack="feather"
            disabled
            icon="icon-play"
            class="mt-2 font-bold px-4 py-2 text-white"
            type="border"
            @click="$router.push(`/labs/${lab.id}/play`)"
            >Complete
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import RadialProgressBar from 'vue-radial-progress';

export default {
  data() {
    return {
      quickLearnFetched: false,
      apps: [],

      quickLearnSimulation: [],
      quickLearnFlashCard: [],
      quickLearnExamEdge: [],
      quickLearnLab: [],

      simulationPlaceholderImage: 'https://connect-cdn.intellectualpoint.com/assets/images/apps/SimulationsIcon.png',
      flashcardPlaceholderImage: 'https://connect-cdn.intellectualpoint.com/assets/images/apps/FlashCardsIcon.png',
      examedgePlaceholderImage: 'https://connect-cdn.intellectualpoint.com/assets/images/apps/ExamEdgeIcon.png',
      labPlaceholderImage: 'https://connect-cdn.intellectualpoint.com/assets/images/apps/LabsIcon.png',
    };
  },
  methods: {
    truncateText(text, limit) {
      if (text) {
        return text.length > limit ? `${text.slice(0, limit)}...` : text;
      }
      return '';
    },
    fetchQuickLearnSimulation() {
      this.$http.get('app/simulations/selector?amount=100&page=1&hidden=false').then((response) => {
        const fetchedSimulations = response.data;

        if (fetchedSimulations.length > 0) {
          fetchedSimulations.sort((a, b) => a.percent - b.percent);

          const lowestPercentSimulations = fetchedSimulations.slice(0, 10);

          const randomlyPickedSimulation = lowestPercentSimulations[Math.floor(Math.random() * lowestPercentSimulations.length)];

          this.quickLearnSimulation.push(randomlyPickedSimulation);
        }
      });
    },

    fetchQuickLearnFlashCard() {
      this.$http.get('app/flashcards/selector').then((response) => {
        const fetchedFlashcards = response.data;

        if (fetchedFlashcards.length > 0) {
          const setsNotCompleted = fetchedFlashcards.reduce((accumulator, flashcard) => {
            return accumulator.concat(flashcard.sets.filter((set) => set.percent === undefined || set.percent <= 100));
          }, []);

          setsNotCompleted.sort(() => Math.random() - 0.5);

          const selectedSets = setsNotCompleted.slice(0, Math.min(5, setsNotCompleted.length));

          const randomlySelectedSet = selectedSets[Math.floor(Math.random() * selectedSets.length)];

          this.quickLearnFlashCard.push(randomlySelectedSet);
        }
      });
    },

    fetchQuickLearnExamEdge() {
      this.$http.get('app/testprep/selector').then((response) => {
        const fetchedExamEdge = response.data.assignments;

        if (fetchedExamEdge.length > 0) {
          let assignmentFound = false;

          for (let i = 0; i < fetchedExamEdge.length; i++) {
            if (!assignmentFound && !fetchedExamEdge[i].complete) {
              allAssignmentsCompleted = false;
              assignmentFound = true;

              this.quickLearnExamEdge.push(fetchedExamEdge[i]);
            }
          }
        }
      });
    },

    fetchQuickLearnLab() {
      this.$http.get('app/labs/selector?amount=300&page=1&hidden=false').then((response) => {
        const fetchedLabs = response.data;

        if (fetchedLabs.length > 0) {
          const randomlySelectedLab = fetchedLabs[Math.floor(Math.random() * fetchedLabs.length)];

          this.quickLearnLab.push(randomlySelectedLab);
        }
      });
    },

    fetchAppData() {
      this.$http.get('app/platform/apps').then((response) => {
        this.apps = response.data;

        for (let i = 0; i < this.apps.length; i++) {
          const currentApp = this.apps[i];

          if (currentApp.id === 'examedge') {
            this.fetchQuickLearnExamEdge();
          }

          if (currentApp.id === 'flashcards') {
            this.fetchQuickLearnFlashCard();
          }

          if (currentApp.id === 'simulations') {
            this.fetchQuickLearnSimulation();
          }

          if (currentApp.id === 'labs') {
            this.fetchQuickLearnLab();
          }
        }

        const numberOfExtraApps = Math.max(0, 4 - this.apps.length);
        for (let i = 0; i < numberOfExtraApps; i++) {
          const randomlySelectedApp = this.apps[Math.floor(Math.random() * this.apps.length)].id;

          switch (randomlySelectedApp) {
            case 'examedge':
              this.fetchQuickLearnExamEdge();
              break;
            case 'flashcards':
              this.fetchQuickLearnFlashCard();
              break;
            case 'simulations':
              this.fetchQuickLearnSimulation();
              break;
            case 'labs':
              this.fetchQuickLearnLab();
              break;
            default:
              break;
          }
        }

        setTimeout(() => {
          this.quickLearnFetched = true;
        }, 800);
      });
    },
    fetchQuickLearnPrelimCheck() {
      if (!this.quickLearnFetched) {
        this.fetchAppData();
      }
    },
  },
  components: {
    Prism,
    RadialProgressBar,
  },
  computed: {
    activeCourseInfo() {
      return this.$store.state.AppActiveCourse;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  mounted() {
    //this.fetchQuickLearnPrelimCheck();
  },
};
</script>

<style scoped>
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  #quick-learn-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media only screen and (min-width: 1201px) and (max-width: 1600px) {
  #quick-learn-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media only screen and (min-width: 1601px) and (max-width: 1850px) {
  #quick-learn-grid {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
</style>
